import {getTenantName} from 'common/HelperFunctions'

export const isAttendanceBetaEnabled = () => {
  const TENANTS_USING_OLD_ATTENDANCE_PORTAL = ['eureka', 'lgs', 'psm', 'risc', 'whales', 'whss']
  return !TENANTS_USING_OLD_ATTENDANCE_PORTAL.includes(getTenantName())
}

export const getMonthOptions = (intl: any) => [
  {label: intl.formatMessage({id: 'MONTH.JANUARY'}), value: '1'},
  {label: intl.formatMessage({id: 'MONTH.FEBRUARY'}), value: '2'},
  {label: intl.formatMessage({id: 'MONTH.MARCH'}), value: '3'},
  {label: intl.formatMessage({id: 'MONTH.APRIL'}), value: '4'},
  {label: intl.formatMessage({id: 'MONTH.MAY'}), value: '5'},
  {label: intl.formatMessage({id: 'MONTH.JUNE'}), value: '6'},
  {label: intl.formatMessage({id: 'MONTH.JULY'}), value: '7'},
  {label: intl.formatMessage({id: 'MONTH.AUGUST'}), value: '8'},
  {label: intl.formatMessage({id: 'MONTH.SEPTEMBER'}), value: '9'},
  {label: intl.formatMessage({id: 'MONTH.OCTOBER'}), value: '10'},
  {label: intl.formatMessage({id: 'MONTH.NOVEMBER'}), value: '11'},
  {label: intl.formatMessage({id: 'MONTH.DECEMBER'}), value: '12'},
]
